import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Manages the filter component for an app.
 *
 * @description This service ensures that only one filter is visible at a time.
 * @export
 * @class FilterService
 */
@Injectable()
export class FilterService {
    public filterStream: Observable<string>;
    private filterSubject = new Subject<string>();
    private _currentFilter: string;

    constructor() {
        this.filterStream = this.filterSubject.asObservable();
    }

    public updateVisibleFilter(filter: string): void {
        this._currentFilter = filter;
        this.filterSubject.next(this._currentFilter);
    }
}
